<template>
  <section class="contact--basic">
    <v-container>
      <v-layout column>
        <v-flex sm12>
          <div class="contact--header-grid">
            <div class="contact--header-col-9">
              <div class="d-flex">
                <v-text-field
                  label="Search Companies By Name"
                  v-model="opts.name"
                  @keyup.enter="query"
                  style="width: 90%;"
                />
                <div>
                  <v-btn icon color="primary" @click="query">
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <div>
              <v-btn outline color="primary" to="/company/create">
                <v-icon left>add</v-icon>Create New
              </v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider/>
    <section>
      <v-container grid-list-md>
        <v-layout column>
          <v-flex sm12>
            <div class="contact--list-grid">
              <div class="contact--span-col-4">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="contact--text-style">NAME</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div class="contact--span-col-2">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="contact--text-style">ADDRESS</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div class="contact--span-col-2">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title class="contact--text-style">PHONE</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <div>
                <v-list-tile-action>
                  <v-btn icon color="primary" disabled>
                    <v-icon>menu</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <v-divider/>
    <section v-if="loaded">
      <v-container grid-list-md>
        <v-layout column>
          <v-flex sm12 v-for="company in companies.docs" :key="company.id">
            <v-card>
              <div class="contact--list-grid">
                <div class="contact--span-col-4">
                  <v-list-tile>
                    <v-list-tile-avatar>
                      <img
                        :src="
                    company.logo || 
                    'https://lh4.googleusercontent.com/-03EW-FpeRBE/AAAAAAAAAAI/AAAAAAAAAAA/ZYNO4RH0oOo/s228-p/photo.jpg'
                    "
                      >
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title style="text-transform: capitalize;">
                        <router-link :to="`/company/${company.id}`">{{company.name}}</router-link>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div class="contact--span-col-2">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{company.address || "NOT FOUND"}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div class="contact--span-col-2">
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>{{company.phone || "NOT FOUND"}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
                <div>
                  <v-list-tile-action>
                    <v-menu bottom left nudge-top="-40">
                      <v-btn slot="activator" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list>
                        <!-- VIEW THE USER -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/company/${company.id}`">
                              <v-icon>remove_red_eye</v-icon>&nbsp;
                              View
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <!-- UPDATE THE USER -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/company/${company.id}?update=1`">
                              <v-icon>edit</v-icon>&nbsp;
                              Update
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                        <!-- DELETE THE USER -->
                        <v-list-tile>
                          <v-list-tile-action>
                            <v-btn flat :to="`/company/${company.id}?delete=1`">
                              <v-icon>delete</v-icon>&nbsp;
                              Delete
                            </v-btn>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action>
                </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex sm12 v-if="(companies.docs || []).length < 1">
            <div class="text-xs-center" style="margin: 50px auto;">
              <h2 style="font-size: 40px;">No Companies Found!</h2>
            </div>
          </v-flex>
        </v-layout>

        <div class="text-xs-center">
          <v-pagination :length="companies.pages" :total-visible="8" v-model="opts.page"/>
        </div>
      </v-container>
    </section>
    <section v-else>
      <Loader/>
    </section>
  </section>
</template>
<script>
import { coreClient } from "../../apollo";
import gql from "graphql-tag";
import Loader from "../../components/loader.vue";
import generateSnackbarError from "../generateSnackbarError";

export default {
  components: {
    Loader
  },
  data() {
    return {
      companies: {},
      opts: {
        name: "",
        page: 1
      },
      loaded: false
    };
  },
  methods: {
    getCompanies(variables = {}) {
      const obs = coreClient.watchQuery({
        query: gql`
          query companies($name: String, $page: Int) {
            Companies(name: $name, page: $page) {
              total
              pages
              page
              docs {
                id
                name
                logo
                address
                phone
              }
            }
          }
        `,
        variables,
        fetchPolicy: "cache-and-network"
      });

      obs.subscribe(
        ({ data, loading }) => {
          this.loaded = !loading;
          if (data) {
            this.companies = data.Companies;
          }
        },
        err => {
          this.loaded = true;
          this.$store.commit(
            "updateSnackbar",
            generateSnackbarError(err, "Companies")
          );
        }
      );
    },
    query() {
      this.getCompanies(this.opts);
    }
  },
  async mounted() {
    let { query } = this.$route;
    this.opts.page = Number(query.page) || this.opts.page;

    await this.query();

    this.$watch("opts.page", async page => {
      this.$router.push({
        name: "Company",
        query: { ...query, page: this.opts.page }
      });

      await this.query();
    });

    this.$watch("opts.name", async val => {
      if (val === "") {
        await this.query();
      }
    });
  }
};
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/Companies.styl';
</style>
